import { getLocationString } from '../../utils/common';
import AvatarImage from '../AvatarImage';
import LinkToMemberDetails from '../LinkToMemberDetails';

const getLocation = ({ profile }) => getLocationString(profile || {}, '');

const MemberItem = ({ member }) => (
  <div className="card mb-5">
    <div className="card-image">
      <figure className="image is-square">
        <AvatarImage member={member} />
      </figure>
    </div>
    <div className="card-content">
      <div className="media">
        <div className="media-content" style={{minHeight: 150}}>
          <p className="title is-4">
            <LinkToMemberDetails member={member} />
          </p>
          <p className="subtitle is-6">{getLocation(member)}</p>
          <p>{member.profile?.intro}</p>
        </div>
      </div>
    </div>
  </div>
);

export default MemberItem;
